import { SwitchAction } from '../../tool/action/switch-action';

export class SwitchActionBuilder<T> {
  private readonly _action: SwitchAction<T>;
  constructor(name: string, icon: string) {
    this._action = new SwitchAction<T>(name, icon, '');
  }

  public setTooltip(tooltip: string): SwitchActionBuilder<T> {
    this._action.tooltip = tooltip;
    return this;
  }

  public setText(text: string): SwitchActionBuilder<T> {
    this._action.text = text;
    return this;
  }

  public setIsActive(isActive: boolean): SwitchActionBuilder<T> {
    this._action.isActive = isActive;
    return this;
  }

  public setAlign(align: 'left' | 'center' | 'right'): SwitchActionBuilder<T> {
    this._action.align = align;
    return this;
  }

  public enable(): SwitchActionBuilder<T> {
    this._action.enable = true;
    return this;
  }

  public disable(): SwitchActionBuilder<T> {
    this._action.enable = false;
    return this;
  }

  public setIconColor(value: string): SwitchActionBuilder<T> {
    this._action.iconColor = value;
    return this;
  }

  public build(): SwitchAction<T> {
    return this._action;
  }
}
